import { useEffect, useState, useRef } from 'react';
import { obtenerEmplAsignados, obtenerPersonaXHorario, obtenerProyecto, obtenerPuesto, obtieneTurnosByPuestoFecha } from '../../services/Monitor/MonitorService';
import { cambiarEmpleadoTurno } from '../../services/HorarioTurno/TurnoService';
import { registraDinamiXCambio } from '../../services/Monitor/ComunicacionService';

const useAjusteHorario = () => {
    const [loadProyecto, setLoadProyecto] = useState(false);
    const [proyecto, setProyecto] = useState(null);
    const [lstProyecto, setLstProyecto] = useState([]);

    const [loadPuesto, setLoadPuesto] = useState(false);
    const [puesto, setPuesto] = useState(null);
    const [lstPuesto, setLstPuesto] = useState([]);

    const [fecha, setFecha] = useState(null);
    const [formatFecha, setFormatFecha] = useState(null);

    const [loadTurno, setLoadTurno] = useState(false);
    const [turno, setTurno] = useState(null);
    const [lstTurno, setLstTurno] = useState([]);

    const [loadEmplSus, setLoadEmplSus] = useState(false);
    const [emplSus, setEmplSus] = useState(null);
    const [lstEmplSus, setLstEmplSus] = useState([]);

    const [loadEmpleado, setLoadEmpleado] = useState(false);
    const [empleado, setEmpleado] = useState(null);
    const [lstEmpleados, setLstEmpleados] = useState([]);

    const [inhabControl, setInhabControl] = useState(true);
    const [procesando, setProcesando] = useState(false);

    const [crearDinamico, setCrearDinamico] = useState(false);
    const [disableHoras, setDisableHoras] = useState(true);
    const [horaIni, setHoraIni] = useState();
    const [horaFin, setHoraFin] = useState();

    const handleChangeCheck = (evt) => {
        setCrearDinamico(evt.checked);
        evt.checked ? setDisableHoras(false) : setDisableHoras(true);
    };

    const toast = useRef(null);

    useEffect(() => {
        const cargaProyecto = async () => {
            try {
                setLoadProyecto(true);
                const datos = await obtenerProyecto();
                //console.log(datos);
                setLstProyecto(datos);
                setLoadProyecto(false);
            } catch (error) {
                console.error(error.message);
            }
        };
        cargaProyecto();
    }, []);

    useEffect(() => {
        const cargarEmpPorProyecto = async () => {
            try {
                setLoadEmplSus(true);
                //const datos = await obtieneEmplePorProyecto(proyecto.id);
                const datos = await obtenerEmplAsignados();
                //console.log('kk002', datos);
                setLstEmplSus(datos);
                setLoadEmplSus(false);
            } catch (error) {
                console.error(error.message);
            }
        };
        cargarEmpPorProyecto();
    }, []);

    useEffect(() => {
        const cargarPuesto = async () => {
            if (proyecto) {
                try {
                    setLoadPuesto(true);
                    const datos = await obtenerPuesto(proyecto.id);
                    setLstPuesto(datos);
                    setLoadPuesto(false);
                } catch (error) {
                    console.error(error.message);
                }
            }
        };
        cargarPuesto();
    }, [proyecto]);

    useEffect(() => {
        const cargarTurno = async () => {
            if (puesto && fecha) {
                try {
                    setLoadTurno(true);
                    const datos = await obtieneTurnosByPuestoFecha(puesto.id, formatFecha);
                    //console.log('QW001:', datos);
                    setLstTurno(datos);
                    setLoadTurno(false);
                    //setInhabControl(false);
                } catch (error) {
                    console.error(error.message);
                }
            }
        };
        cargarTurno();
    }, [puesto, fecha]);

    useEffect(() => {
        const obtenerEmpXPuesto = async () => {
            if (turno) {
                const objDatos = {
                    puestoId: puesto.id,
                    fecha: convertDate(fecha),
                    horarioId: turno.horarioId
                };
                //
                setLoadEmpleado(true);
                try {
                    const miResponse = await obtenerPersonaXHorario(objDatos);
                    setLstEmpleados(miResponse);
                    setInhabControl(false);
                } catch (error) {
                    console.error('Error al obtener personas');
                } finally {
                    setLoadEmpleado(false);
                }
            }
        };
        obtenerEmpXPuesto();
    }, [turno]);

    const convertDate = (fecha) => {
        let anio = fecha.getFullYear();
        let mes = String(fecha.getMonth() + 1).padStart(2, '0');
        let dia = String(fecha.getDate()).padStart(2, '0');
        return `${anio}-${mes}-${dia}`;
    };

    const handleDatechange = (evt) => {
        setFecha(evt.value);
        const anio = evt.value.getFullYear();
        const mes = String(evt.value.getMonth() + 1).padStart(2, '0');
        const dia = String(evt.value.getDate()).padStart(2, '0');
        //console.log('WW01', `${anio}-${mes}-${dia}`);
        setFormatFecha(`${anio}-${mes}-${dia}`);
    };

    const emplesusItemTemplate = (itemFila) => {
        return (
            <span>
                {itemFila.identificacion} - {itemFila.nombre}{' '}
            </span>
        );
    };
    const emplesusItmSelTemplate = (itemFila, props) => {
        if (itemFila) {
            return (
                <span>
                    {itemFila.identificacion} - {itemFila.nombre}{' '}
                </span>
            );
        }
        return <span>{props.placeholder}</span>;
    };

    const turnoItemTemplate = (itemFila) => {
        if (itemFila) {
            return (
                <span>
                    {itemFila.horarioSigla} - {itemFila.horarioNombre}{' '}
                </span>
            );
        }
    };

    const turnoValueTemplate = (itemFila, props) => {
        if (itemFila) {
            return (
                <span>
                    {itemFila.horarioSigla} - {itemFila.horarioNombre}
                </span>
            );
        }
        return <span>{props.placeholder}</span>;
    };

    const convertHoraString = (hora) => {
        if (!hora) return;
        const horas = hora.getHours().toString().padStart(2, '0');
        const minutos = hora.getMinutes().toString().padStart(2, '0');
        const segundos = hora.getSeconds().toString().padStart(2, '0');
        return `${horas}:${minutos}:${segundos}`;
    };
    const convertFechaString = (fecha) => {
        if (!fecha) return;
        const anio = fecha.getFullYear();
        const mes = String(fecha.getMonth() + 1).padStart(2, '0');
        const dia = String(fecha.getDate()).padStart(2, '0');
        return `${anio}-${mes}-${dia}`;
    };

    const handleClick = async () => {
        if (!(emplSus && empleado && turno)) {
            toast.current.show({ severity: 'warn', summary: 'Warning', detail: 'Debe seleccionar Turno, Empleado y Empleado Reemplazo', life: 3000 });
            return;
        }
        if (emplSus.personaId === empleado.empleadoId) {
            toast.current.show({ severity: 'warn', summary: 'Warning', detail: 'Empleado y Empleado Reemplazo deben ser diferentes', life: 3000 });
            return;
        }
        if (crearDinamico) {
            if (!(horaIni && horaFin)) {
                toast.current.show({ severity: 'warn', summary: 'Warning', detail: 'Debe ingresar Hora inicio y Hora Fin', life: 3000 });
                return;
            }
        }

        const datosPost = {
            turnoId: turno.turnoId,
            persona: emplSus.personaId
        };
        //console.log('datos:', datosPost)
        setProcesando(true);
        try {
            let response;
            let procesoBien = false;
            if (crearDinamico) {
                //
                horaIni.setSeconds(0, 0)
                horaFin.setSeconds(0, 0)
                const objPostDina = {
                    turnoId: turno.turnoId,
                    personaId: emplSus.personaId,
                    fecha: convertFechaString(fecha),
                    horaInicio: convertHoraString(horaIni),
                    horaFinal: convertHoraString(horaFin)
                };
                //console.log('GGA00:', objPostDina)
                response = await registraDinamiXCambio(objPostDina);
                if (response.horaDetalleDinamicoId) procesoBien=true
            } else {
                //console.log('GGA00:', datosPost)
                response = await cambiarEmpleadoTurno(datosPost);
                if(response.turnoId) procesoBien=true
            }
            if (procesoBien) {
                toast.current.show({ severity: 'success', summary: 'Success', detail: `Cambio Realizado, turnoId: ${turno.turnoId}`, life: 3000 });
                setPuesto(null);
                setFecha(null);
                setFormatFecha(null);
                setTurno(null);
                setEmpleado(null);
                setEmplSus(null);
            }
        } catch (error) {
            console.error('Error al cambiar empleado');
            toast.current.show({ severity: 'error', summary: 'Error', detail: error.message || 'Error al registrar cambio', life: 6000 });
        } finally {
            setProcesando(false);
        }
    };

    return {
        loadProyecto,
        lstProyecto,
        proyecto,
        setProyecto,
        loadPuesto,
        puesto,
        lstPuesto,
        setPuesto,
        fecha,
        handleDatechange,
        loadTurno,
        turno,
        lstTurno,
        setTurno,
        loadEmplSus,
        emplSus,
        setEmplSus,
        lstEmplSus,
        inhabControl,
        procesando,
        empleado,
        setEmpleado,
        handleClick,
        toast,
        emplesusItemTemplate,
        emplesusItmSelTemplate,
        turnoItemTemplate,
        turnoValueTemplate,
        lstEmpleados,
        loadEmpleado,
        crearDinamico,
        disableHoras,
        horaIni,
        setHoraIni,
        horaFin,
        setHoraFin,
        handleChangeCheck
    };
};

export default useAjusteHorario;
